import React, { useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
  Theme,
  makeStyles,
} from '@material-ui/core';

import { H4Text, colors } from 'design-system';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    borderRadius: theme.spacing(1.25),
  },
  actionButtonContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  actionButtons: {
    color: colors.bright_turquoise,
  },
  msg: {
    fontWeight: 'normal',
  },
}));

export type Props = {
  onConfirm: () => void;
  onReject: () => void;
};

const QuotationEditButton = ({ onConfirm, onReject }: Props): JSX.Element => {
  const classes = useStyles();
  const [showConfirm, setShowConfirm] = useState<boolean>(false);

  function handleOnConfirm(e: React.SyntheticEvent): void {
    e.stopPropagation();
    setShowConfirm(false);
    onConfirm();
  }

  function handleOnReject(e: React.SyntheticEvent): void {
    e.stopPropagation();
    setShowConfirm(false);
    onReject();
  }

  return (
    <>
      <Dialog
        data-testid="dialog"
        open={showConfirm}
        PaperProps={{ classes: { root: classes.container } }}
        onClose={handleOnReject}
        onClick={(e): void => e.stopPropagation()}
      >
        <DialogContent>
          <DialogContentText>
            <H4Text className={classes.msg} data-testid="dialog-msg">
              Al editar esta cotización estarás
              <br /> generando una nueva cotización
              <br /> para este mismo cliente.
            </H4Text>
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.actionButtonContainer}>
          <Button
            id="sales-web-button-cloneconfirm"
            data-testid="confirm-action"
            className={classes.actionButtons}
            autoFocus
            onClick={handleOnConfirm}
          >
            OK
          </Button>
          <Button
            id="sales-web-button-clonereject"
            data-testid="reject-action"
            className={classes.actionButtons}
            autoFocus
            onClick={handleOnReject}
          >
            CANCELAR
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        id="sales-web-button-clone"
        data-testid="open-button"
        onClick={(e): void => {
          e.stopPropagation();
          setShowConfirm(true);
        }}
      >
        <img src="./svg/quotation_edit_button.svg" alt="edit" />
      </IconButton>
    </>
  );
};

export default QuotationEditButton;
